export default {
    METRIC: 'metric',
    STATUTE_US: 'statute_us',
    STATUTE_UK: 'statute_uk',
    METER: 'meter',
    YARD: 'yard'
};
